import { cn } from '@/utils'
import { ASPECT } from '../../constants'
import '@/lib/cad/screenshot-overlay.css'
import { useCADPageStore } from '@/state'

export const ScreenshotOverlay = () => {
  const canvasSize = useCADPageStore((state) => state.canvasSize)
  const hovered = useCADPageStore((state) => state.createViewButtonHover)

  const overlayWidth = Math.min(canvasSize.width, canvasSize.height * ASPECT)
  const overlayHeight = overlayWidth / ASPECT

  return (
    <div
      className={cn('pointer-events-none absolute m-auto inset-0 w-fit h-fit', {
        'screenshot-hover-effect': hovered,
      })}
    >
      <div className="lines"></div>
      <div className="angles"></div>
      <div
        className="overlay"
        style={{
          width: `${overlayWidth}px`,
          height: `${overlayHeight}px`,
        }}
      />
    </div>
  )
}
